import DatasetItem from '@/pages/AutomationPage/components/DatasetItem.tsx';
import { Center, ScrollArea, Text } from '@mantine/core';
import { Run } from '@/types/runs.ts';
import { Dataset } from '@/types/datasets.ts';

type props = {
  run: Run;
  datasets: Dataset[];
  type: 'inputs' | 'outputs';
};

const height = '180px';

const FilesList = ({ run, datasets, type }: props) => {
  return (
    <ScrollArea w="100%" h={height} mt={'xs'}>
      {datasets.length === 0 && (
        <Center px={'sm'} h={height}>
          <Text>No {type}</Text>
        </Center>
      )}
      {datasets.map((dataset, index) => (
        <DatasetItem
          dataset={dataset}
          key={dataset.id}
          run={run}
          // bottomBorder={index < datasets.length - 1 || datasets.length === 1}
          bottomBorder={index < datasets.length - 1}
        />
      ))}
    </ScrollArea>
  );
};

export default FilesList;
